function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ii_137_5825)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_137_5825)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.747559,
  y: 0.259277,
  width: 73.2525,
  height: 37.4811,
  rx: 18.7406,
  fill: "url(#paint0_radial_137_5825)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_dd_137_5825)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 19.4343,
  cy: 18.9998,
  r: 19.4343,
  fill: "url(#paint1_linear_137_5825)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19.4343,
  cy: 18.9998,
  r: 17.5657,
  stroke: "url(#paint2_linear_137_5825)",
  strokeWidth: 3.73737
}))));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ii_137_5825",
  x: 0.747559,
  y: 0.259277,
  width: 73.2524,
  height: 38.9759,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.747475,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect1_innerShadow_137_5825"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.49495
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.86869
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_137_5825"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1.49495,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect2_innerShadow_137_5825"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.747475
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_137_5825",
  result: "effect2_innerShadow_137_5825"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_dd_137_5825",
  x: -3.73737,
  y: -3.42447,
  width: 46.3434,
  height: 50.0808,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.747475,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect1_dropShadow_137_5825"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4.48485
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.24242
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_137_5825"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.49495
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_137_5825",
  result: "effect2_dropShadow_137_5825"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_137_5825",
  result: "shape"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_137_5825",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(37.3738 37.7404) rotate(-90) scale(37.4811 73.2525)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.140625,
  stopColor: "#F2F2F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#757575"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3B3B3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_137_5825",
  x1: 19.4343,
  y1: -0.43457,
  x2: 19.4343,
  y2: 38.4341,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4F4F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_137_5825",
  x1: 19.4343,
  y1: -0.43457,
  x2: 19.4343,
  y2: 38.4341,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ECECEC"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_137_5825"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.747559,
  y: 0.259277,
  width: 73.2525,
  height: 37.4811,
  rx: 18.7406,
  fill: "white"
})));

function SvgToggleDisable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 51,
    viewBox: "0 0 78 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleDisable);
export default __webpack_public_path__ + "static/media/toggleDisable.4f18158c8fffc1b5336c585ecd0981549792957edb2fe9f8abc0e07eef92a8c5.svg";
export { ForwardRef as ReactComponent };